// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JfM6","newExpiryDate":"styles_newExpiryDate__1UYhZ","footer":"styles_footer__1_Ck8"};